
<div class="">
  <button v-if="documents.length" class="btn btn-link text-primary text-decoration-none font-weight-bold" @click="toggleSelectAllDocuments">{{ allDocumentsSelected ? 'Unselect all document' : 'Select all document' }}</button>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Filename</th>
          <th class="text-left">Case Name</th>
          <th class="text-left">Uploaded</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="3" class="primary--text">
            <v-icon small color="primary">mdi-upload-outline</v-icon>
            <h5 color="primary" @click="openUpload" class="hover ml-1">
              Upload File
            </h5>
            <UploadDocumentModal :dialog="dialogUpload" @toggle-modal="toggleDialog"/>
          </td>
        </tr>
        <Row v-for="file in documents" :key="file.id" :file="file" :isSelected="isSelected(file.id)" @toggle-selection="handleToggleSelection" />
        <BottomActionBar v-if="selectedDocuments.length" :selected-documents="selectedDocuments" @clear-selection="clearSelection" />
      </tbody>
    </template>
  </v-simple-table>
</div>
